//@flow
import * as React from 'react';
import { Field, reduxForm, formValueSelector,change } from 'redux-form';
import { connect } from 'react-redux';
import ContainerRowSpace from '../../components/common/ContainerRowSpace'
import ContainerRowReduxTextField from '../../components/common/ContainerRowReduxTextField'
import * as actions from '../../redux/harmonia/actions';

const cancelButtonOnClick=(e,props)=>{
    e.preventDefault();
    props.cancelAddEditLineItemForm();
}

const refreshLineTotal=(props)=>{
    const { itemQty,itemPrice } = props;
    let itemTotal=0
    if (itemQty && itemPrice){
        itemTotal=itemQty * itemPrice
    }
    props.changeFieldValue('itemTotal',itemTotal)
}

const refreshLineQtyForLineTotal=(e,props)=>{
    const { itemPrice } = props;
    let lineTotal = 0
    if (e.target.value && itemPrice){
        lineTotal = e.target.value * itemPrice
    }
    props.changeFieldValue('itemTotal',lineTotal)
}

const isOverrideLineQty=(e,props)=>{
    if (e.target.checked){
        props.changeFieldValue('itemQty',null)
        refreshLineQtyForLineTotal(e,props)
    }
}

const itemPriceOnChange=(e,props)=>{
    const { demeter,itemQty } = props;
    
    let itemTotal=0
    if (itemQty && e.target.value){
        itemTotal=itemQty * e.target.value
    }
    props.changeFieldValue('itemTotal',itemTotal)
}

const isOverrideNaItemPriceOnChange=(e,props)=>{
    if (e.target.checked){
        props.changeFieldValue('itemPrice',null)
        itemPriceOnChange(e,props)
    }
}

const SaveAndCancelButtons=props=>(
    <div className='row'>
        <div className="col-sm">
            <button className="btn btn-outline-primary" type="submit" disabled={props.pristine || props.submitting}>
                Save
            </button>
            &nbsp;&nbsp;&nbsp;
            <button className="btn btn-outline-secondary" type="button" onClick={(e)=>cancelButtonOnClick(e,props)}>
                Cancel
            </button>
        </div>
    </div>
)

const Title=props=>(
    <div className='row'>
        <div className='col-sm'>
            <h5>Add/Edit Line Item</h5>
        </div>
    </div>
)

const AddEditLineItemForm = props => {
    const { handleSubmit,pristine,submitting, initialValues  } = props;
    
    return (
          <div className='container'>
            <ContainerRowSpace /> 
            <ContainerRowSpace /> 
            <Title />
            <form onSubmit={handleSubmit} >
                <ContainerRowReduxTextField field={'itemDesc'} label={'Line Description'} />
                <ContainerRowReduxTextField field={'itemAmount'} label={'Line Amount'} textType={'number'} />
                <SaveAndCancelButtons {...props}/>
            </form>
            <ContainerRowSpace /> 
          </div>  
        
    )
}

const validate = (values,props) => {
    const errors = {};
    const { isOverrideItemTotal,demeter }=props;
    
    let requiredFields = [
        'itemDesc',
        'itemAmount'
    ];

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Required'
        }
    })

    return errors;
}

const submit = (values, dispatch, props) => {
    const { jwt,taskAcceptedInfoId,harmonia } = props;
    let newLineItem=values;
    const { lineItem } = harmonia
    
    if (lineItem && lineItem.id){
        props.updateLineItem(jwt,values,lineItem.id);
    }else{
        props.createNewLineItem(jwt,newLineItem,taskAcceptedInfoId);
    }
}

const form='harmoniaAddEditLineItemForm'

const AddEditLineItemReduxForm = reduxForm({
    form: form,
    enableReinitialize: true,
    validate,
    onSubmit: submit,
})(AddEditLineItemForm)

const selector = formValueSelector(form)

const mapStateToProps:any = (state, ownProps) => {
    return {
        harmonia: state.harmonia,
        initialValues: state.harmonia.lineItem
    }
}

const mapDispatchToProps:any = (dispatch, ownProps) => {
    return {
      createNewLineItem: (jwt,newLineItem,taskAcceptedInfoId) => {
        dispatch(actions.createNewLineItem(jwt,newLineItem,taskAcceptedInfoId))  
      },
      updateLineItem: (jwt,updateLineItem,id) => {
        dispatch(actions.updateLineItem(jwt,updateLineItem,id))  
      },
      cancelAddEditLineItemForm: () => {
        dispatch(actions.cancelAddEditLineItemForm())  
      },
      changeFieldValue: (field, value)=> {
        dispatch(change(form, field, value))
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(AddEditLineItemReduxForm);


// WEBPACK FOOTER //
// ./src/views/ProjectHarmonia/AddLineItemForm.js